
import {
  Component,
  Vue,
  Prop,
  Model,
  Emit,
  Watch
} from "vue-property-decorator";
import ModalHeader from "@/components/modal-header.vue";
import { AsrItem, AsrItemGroup, Answer } from "@/lib/model/exam/result";

@Component({
  components: {
    ModalHeader
  }
})
export default class CandidateAnswerSection extends Vue {
  name = "candidate-answer-section";
  @Prop() data!: any;
  @Prop() answerIndex!: number;
  @Prop() playTime!: number;
  @Prop() active!: boolean;
  @Prop() pdfIng!: boolean;
  @Prop() questionIndexAppendIndex!: number[]; //正在播放的追问视频 [questionIndex, appendIndex]
  highLightIndex = -1;

  get questionList() {
    console.log(this.data.questionList);
    return this.data.questionList.filter((q: any) =>
      [1, 7, 6, 8, 5].includes(q.type)
    );
  }

  @Watch("playTime")
  onPlayTimeChange(to: any, from: any) {
    if (!to) {
      this.highLightIndex = -1;
    }
    //处理主回答
    this.answerList[this.answerIndex].asrList.forEach(
      (asrItem: AsrItem, i: number) => {
        if (this.questionIndexAppendIndex[1] !== -1) {
          //正在播放追问
          asrItem.highLight = false;
          return;
        } else {
          asrItem.highLight = to >= asrItem.bg && to <= asrItem.ed;
        }
      }
    );
    //处理追问
    this.answerList[this.answerIndex].videoAppendAnswerList.forEach(
      (asrGroup: any, i: number) => {
        if (this.questionIndexAppendIndex[1] === -1) {
          //正在播放主回答
          asrGroup.asrList.forEach((asrItem: AsrItem, i: number) => {
            asrItem.highLight = false;
          });
          return;
        }
        if (i !== this.questionIndexAppendIndex[1]) {
          //正在播放追问，但不是当前追问
          asrGroup.asrList.forEach((asrItem: AsrItem, i: number) => {
            asrItem.highLight = false;
          });
          return;
        } else {
          //正在播放当前追问
          asrGroup.asrList.forEach((asrItem: AsrItem, i: number) => {
            asrItem.highLight = to >= asrItem.bg && to <= asrItem.ed;
          });
        }
      }
    );
  }

  answerList: Answer[] = [];

  mounted() {
    console.log(this.data);
    this.answerList = this.data.answerList.filter((a: any) =>
      [1, 7, 6, 8, 5].includes(a.type)
    );
  }

  //asr内容
  asrText(list: any) {
    if (list.length === 0) {
      return "未识别出内容";
    }
    let text = "";
    list.forEach((d: any) => {
      text += d.txt;
    });
    return text;
  }

  onClickAsrItem(asrItem: AsrItem, appendIndex = -1) {
    this.$emit("on-click-asr-item", {
      answerIndex: this.answerIndex,
      appendIndex: appendIndex,
      time: asrItem.bg
    });
  }
}
